'use client';

import { Hreflang } from '@/integrations/crystallize/__gql-codegen-types/catalogue/graphql';
import {
  createContext, useContext, useState, ReactNode,
} from 'react';
import { HreflangContextType } from './types/HreflangContextType';

const HreflangContext = createContext<HreflangContextType | undefined>(undefined);

export function HreflangProvider({ children }: { children: ReactNode }) {
  const [hreflangs, setHreflangs] = useState<Hreflang[] | null>(null);

  return (
    <HreflangContext.Provider value={{ hreflangs, setHreflangs }}>
      {children}
    </HreflangContext.Provider>
  );
}

export function useHreflang() {
  const context = useContext(HreflangContext);
  if (!context) {
    throw new Error('useHreflang must be used within a HreflangProvider');
  }
  return context;
}
